var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phosphor/Duotone/WarningCircle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.2,
    d: "M17.6953 10.7637C17.6953 12.247 17.2554 13.6971 16.4313 14.9304C15.6072 16.1638 14.4359 17.1251 13.0654 17.6928C11.695 18.2604 10.187 18.4089 8.73214 18.1196C7.27728 17.8302 5.94091 17.1159 4.89201 16.067C3.84312 15.0181 3.12882 13.6817 2.83943 12.2268C2.55004 10.772 2.69856 9.26399 3.26622 7.89355C3.83388 6.5231 4.79517 5.35176 6.02854 4.52765C7.26191 3.70354 8.71196 3.26367 10.1953 3.26367C12.1844 3.26367 14.0921 4.05385 15.4986 5.46037C16.9051 6.86689 17.6953 8.77455 17.6953 10.7637Z",
    fill: "url(#paint0_linear_2486_15857)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.1953 2.63867C8.58834 2.63867 7.01746 3.11519 5.68131 4.00798C4.34516 4.90077 3.30376 6.16972 2.68879 7.65437C2.07383 9.13902 1.91293 10.7727 2.22644 12.3488C2.53994 13.9249 3.31377 15.3726 4.45007 16.5089C5.58638 17.6452 7.03411 18.419 8.61021 18.7326C10.1863 19.0461 11.82 18.8852 13.3046 18.2702C14.7893 17.6552 16.0582 16.6138 16.951 15.2777C17.8438 13.9415 18.3203 12.3706 18.3203 10.7637C18.318 8.60949 17.4613 6.54418 15.938 5.02094C14.4148 3.4977 12.3495 2.64095 10.1953 2.63867ZM10.1953 17.6387C8.83557 17.6387 7.50636 17.2355 6.37577 16.48C5.24518 15.7246 4.364 14.6509 3.84364 13.3946C3.32329 12.1384 3.18714 10.756 3.45242 9.42243C3.71769 8.08881 4.37247 6.8638 5.33396 5.90231C6.29544 4.94083 7.52045 4.28605 8.85407 4.02077C10.1877 3.7555 11.57 3.89165 12.8263 4.412C14.0825 4.93235 15.1562 5.81354 15.9117 6.94413C16.6671 8.07471 17.0703 9.40393 17.0703 10.7637C17.0682 12.5864 16.3433 14.3339 15.0544 15.6227C13.7655 16.9116 12.018 17.6366 10.1953 17.6387ZM9.57032 11.3887V7.01367C9.57032 6.84791 9.63616 6.68894 9.75337 6.57173C9.87058 6.45452 10.0296 6.38867 10.1953 6.38867C10.3611 6.38867 10.52 6.45452 10.6373 6.57173C10.7545 6.68894 10.8203 6.84791 10.8203 7.01367V11.3887C10.8203 11.5544 10.7545 11.7134 10.6373 11.8306C10.52 11.9478 10.3611 12.0137 10.1953 12.0137C10.0296 12.0137 9.87058 11.9478 9.75337 11.8306C9.63616 11.7134 9.57032 11.5544 9.57032 11.3887ZM11.1328 14.2012C11.1328 14.3866 11.0778 14.5678 10.9748 14.722C10.8718 14.8762 10.7254 14.9964 10.5541 15.0673C10.3828 15.1383 10.1943 15.1568 10.0124 15.1207C9.83056 15.0845 9.66352 14.9952 9.5324 14.8641C9.40129 14.733 9.312 14.5659 9.27583 14.3841C9.23966 14.2022 9.25822 14.0137 9.32918 13.8424C9.40014 13.6711 9.5203 13.5247 9.67447 13.4217C9.82864 13.3187 10.0099 13.2637 10.1953 13.2637C10.444 13.2637 10.6824 13.3624 10.8582 13.5383C11.034 13.7141 11.1328 13.9525 11.1328 14.2012Z",
    fill: "url(#paint1_linear_2486_15857)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2486_15857",
    x1: 2.69531,
    y1: 18.2637,
    x2: 14.02,
    y2: 14.4692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF375F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2486_15857",
    x1: 2.07031,
    y1: 18.8887,
    x2: 14.3387,
    y2: 14.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF375F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircle);
export default __webpack_public_path__ + "static/media/WarningCircle.04effe00342beffd314c4dbbf8411cd1.svg";
export { ForwardRef as ReactComponent };